import { Turbo } from "@hotwired/turbo-rails"

Turbo.StreamActions.refresh = function () {
  Turbo.visit(window.location.href)
}
